export enum ProductType {
    product = "PRODUCT",
    productCategory = "PRODUCT_CATEGORY",
}
